import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["required", "id", "name", "true-value", "false-value", "disabled", "value", "checked"]

import { ref, watch, Ref } from "vue";

type GreenifiedCheckboxProps = {
  required?: boolean;
  id?: string;
  name?: string;
  value?: string | number | boolean;
  modelValue?: string | number | boolean | null;
  label?: string;
  vertical?: boolean;
  showError?: boolean;
  trueValue?: string | number | boolean | null;
  falseValue?: string | number | boolean | null;
  tableMargin?: "main" | "sub" | "none";
  isChecked?: boolean;
  size?: "large" | "small";
  disabled?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GreenifiedCheckbox',
  props: {
    required: { type: Boolean, default: false },
    id: { default: "" },
    name: { default: "" },
    value: { type: [String, Number, Boolean], default: "" },
    modelValue: { type: [String, Number, Boolean, null], default: null },
    label: { default: "" },
    vertical: { type: Boolean, default: false },
    showError: { type: Boolean, default: false },
    trueValue: { type: [String, Number, Boolean, null], default: true },
    falseValue: { type: [String, Number, Boolean, null], default: false },
    tableMargin: { default: "none" },
    isChecked: { type: Boolean, default: false },
    size: { default: "small" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "input"],
  setup(__props: any, { emit: __emit }) {

const greenifiedCheckboxProps = __props;

const emit = __emit;

const selected: Ref<string | number | boolean | null> = ref(
  greenifiedCheckboxProps.modelValue ?? greenifiedCheckboxProps.value
);

watch(
  () => greenifiedCheckboxProps.modelValue,
  newValue => {
    selected.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["checkbox-wrapper position-relative", [
      __props.showError && 'error-checkbox',
      `${__props.tableMargin}-margin`,
      `checkbox-${__props.size}`
    ]]),
      onClick: _cache[2] || (_cache[2] = 
      () => {
        if (selected.value === __props.trueValue) {
          selected.value = __props.falseValue;
        } else {
          selected.value = __props.trueValue;
        }
      }
    )
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        required: __props.required,
        id: __props.id,
        name: __props.name,
        class: _normalizeClass(`checkbox-${__props.size}`),
        "true-value": __props.trueValue,
        "false-value": __props.falseValue,
        disabled: __props.disabled,
        value: __props.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        onInput: _cache[1] || (_cache[1] = 
        event => {
          if (__props.disabled) return;
          emit('update:modelValue', selected.value);
          emit('input', event);
        }
      ),
        checked: __props.isChecked
      }, null, 42, _hoisted_1), [
        [_vModelCheckbox, selected.value]
      ])
    ], 2),
    (__props.label)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["subheading-tiny", [__props.vertical && 'mb-1', __props.showError && 'error-text']])
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})